import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';

import * as mediaActions from 'modules/medias/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

const adapter = createEntityAdapter({ selectId: ({ id }: {id: string}) => id });

export default combineReducers({
  loading: loading(mediaActions.DEFROST_MEDIAS_REQUEST),
  data: createReducer(adapter.getInitialState(), {
    [LOCATION_CHANGE]: adapter.removeAll,
    [mediaActions.DEFROST_MEDIAS_SUCCESS]: adapter.addMany,
  }),
});
